import Base from 'app/models/base';

import moment from 'moment';
import { getStoredValue } from 'utils/storage';
import DateRange from 'app/models/date_range';
import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('subscriptions'),
  initialize() {
    this.set('plan',JSON.parse(getStoredValue('epsubplan')) || {});
    this.dateRange = new DateRange({
      startDatetime: moment.utc()
    });
  },
  getNextPaymentDate() {
    var plan = this.get('plan');

    return this.dateRange.get('startDatetime').add(1, plan.frequency).format('MMMM DD, YYYY');
  },
});



// WEBPACK FOOTER //
// ./app/models/subscription.js